import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'role', method: 'POST', body: body, token: token })
}
